module.exports = __webpack_public_path__ + "img/bgV3.ea479efc.jpg";